import { HEADER_CONTENT_MAX_WIDTH } from 'Util/constants'
import { Toolbar } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  ...(theme.palette.mode === 'light'
    ? {
        backgroundColor: theme.palette.midnight.main
      }
    : {
        backgroundColor: theme.palette.background.paper
      }),
  maxWidth: HEADER_CONTENT_MAX_WIDTH
}))

export default StyledToolbar
